export default __webpack_public_path__ + "static/media/Wompi40x40.1afe40ad.png";